<template>
  <div>
    <b-row class="match-height">
      <b-col lg="3" md="3">
        <b-card v-if="congratulations" class="card-congratulation-medal">
          <h5>Doanh thu bán hàng Online dự kiến</h5>
          <b-card-text class="font-small-3">
            Tính trên đơn đã thanh toán/ COD
          </b-card-text>
          <h3 class="mb-75 mt-2 pt-50">
            <b-link>{{ congratulations.expectation | number }}đ</b-link>
          </h3>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
          >
            Xem chi tiết
          </b-button>
          <!-- <b-img
            :src="require('@/assets/images/illustration/badge.svg')"
            class="congratulation-medal"
            alt="Medal Pic"
          /> -->
        </b-card>
      </b-col>
      <b-col lg="3" md="3">
        <b-card v-if="congratulations" class="card-congratulation-medal">
          <h5>Doanh thu bán hàng Online thực tế</h5>
          <b-card-text class="font-small-3">
            Tính trên đơn hoàn thành giao hàng
          </b-card-text>
          <h3 class="mb-75 mt-2 pt-50">
            <b-link>{{ congratulations.actual | number }}đ</b-link>
          </h3>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
          >
            Xem chi tiết
          </b-button>
          <b-img
              :src="require('@/assets/images/illustration/badge.svg')"
              alt="Medal Pic"
              class="congratulation-medal"
          />
        </b-card>
      </b-col>
      <b-col lg="6" md="6">
        <b-card v-if="statisticsItems" class="card-statistics" no-body>
          <b-card-header>
            <b-card-title>Thống kê</b-card-title>
          </b-card-header>
          <b-card-body class="statistics-body">
            <b-row>
              <b-col
                  v-for="item in statisticsItems"
                  :key="item.icon"
                  :class="item.customClass"
                  sm="6"
                  xl="3"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar :variant="item.color" size="48">
                      <feather-icon :icon="item.icon" size="24"/>
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.title }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ item.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col lg="4">
        <b-row class="match-height">
          <b-col cols="6" lg="6" md="3">
            <b-card v-if="statisticsOrder" body-class="pb-50">
              <h6>Đơn hàng theo ngày</h6>
              <h2 class="font-weight-bolder mb-1">
                {{ other.toDayCount }}
                <small class="h7 text-secondary"
                >hôm nay, <b>{{ other.toDaySimCount }}</b> SIM</small
                >
              </h2>
              <!-- chart -->
              <vue-apex-charts
                  ref="statisticsOrderRef"
                  :options="statisticsOrder.chartOptions"
                  :series="statisticsOrder.series"
                  height="70"
              />
            </b-card>
          </b-col>
          <!--/ Bar Chart - Orders -->
          <b-col cols="6" lg="6" md="3">
            <!--<ecommerce-profit-chart :data="data.statisticsProfit" />-->
            <b-card
                v-if="statisticsProfit"
                body-class="pb-50"
                class="card-tiny-line-stats"
            >
              <h6>Doanh thu theo ngày</h6>
              <h4 class="font-weight-bolder mb-1">
                {{ other.toDaySum | number }}đ
                <small class="h7 text-secondary">hôm nay</small>
              </h4>
              <!-- chart -->
              <vue-apex-charts
                  ref="statisticsProfitRef"
                  :options="statisticsProfit.chartOptions"
                  :series="statisticsProfit.series"
                  height="70"
              />
            </b-card>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <!-- Bar Chart - Orders -->

          <b-col lg="12" md="6">
            <!--<ecommerce-earnings-chart :data="data.earningsChart" />-->
            <b-card v-if="earningsChart" class="earnings-card">
              <b-row class="match-height">
                <b-col cols="12">
                  <div class="text">
                    <div class="progress-wrapper">
                      <b-card-text class="mb-0"> Tìm kiếm số</b-card-text>
                      <b-progress v-model="earningsChart.series[0]" max="100"/>
                    </div>
                    <div class="progress-wrapper">
                      <b-card-text class="mb-0"> Chọn gói</b-card-text>
                      <b-progress
                          v-model="earningsChart.series[1]"
                          max="100"
                          variant="warning"
                      />
                    </div>
                    <div class="progress-wrapper">
                      <b-card-text class="mb-0"> Nhập thông tin</b-card-text>
                      <b-progress
                          v-model="earningsChart.series[2]"
                          max="100"
                          variant="info"
                      />
                    </div>
                    <div class="progress-wrapper">
                      <b-card-text class="mb-0">
                        Thanh toán {{ earningsChart.series[3] + "%" }}
                      </b-card-text>
                      <b-progress
                          v-model="earningsChart.series[3]"
                          max="100"
                          variant="success"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>

      <!-- Revenue Report Card -->
      <b-col lg="4">
        <!--<ecommerce-revenue-report :data="data.revenue" />-->
        <b-card no-body>
          <b-card-header>
            <h4 class="mb-0">Xử lý đơn hàng</h4>
            <b-card-text class="font-medium-5 mb-0">
              <feather-icon
                  class="text-muted cursor-pointer"
                  icon="HelpCircleIcon"
                  size="21"
              />
            </b-card-text>
          </b-card-header>
          <div class="card-body">
            <!-- apex chart -->
            <vue-apex-charts
                :options="goalOverviewRadialBar.chartOptions"
                :series="goalOverviewRadialBar.series"
                height="245"
                type="radialBar"
            />
          </div>
          <b-row class="text-center mx-0">
            <b-col
                class="
                border-top border-right
                d-flex
                align-items-between
                flex-column
                py-1
              "
                cols="6"
            >
              <b-card-text class="text-muted mb-0"> Completed</b-card-text>
              <h3 class="font-weight-bolder mb-50">
                {{ goal_overview.completed }}
              </h3>
            </b-col>

            <b-col
                class="border-top d-flex align-items-between flex-column py-1"
                cols="6"
            >
              <b-card-text class="text-muted mb-0"> In Progress</b-card-text>
              <h3 class="font-weight-bolder mb-0">
                {{ goal_overview.inProgress }}
              </h3>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4">
        <b-row class="match-height" style="height: 100%">
          <b-col cols="6">
            <statistic-card-vertical
                :statistic="other.card1"
                class="pt-0 pb-1"
                color="warning"
                icon="CreditCardIcon"
                statistic-title="Đơn thanh toán lỗi"
            />
          </b-col>
          <b-col cols="6">
            <statistic-card-vertical
                :statistic="other.card2"
                class="pt-0 pb-1"
                color="warning"
                icon="RadioIcon"
                statistic-title="Đơn chưa khởi tạo"
            />
          </b-col>
          <b-col cols="6">
            <statistic-card-vertical
                :statistic="other.card3"
                class="pt-0 pb-1"
                color="danger"
                icon="TruckIcon"
                statistic-title="Đơn chưa có vận đơn"
            />
          </b-col>
          <b-col cols="6">
            <statistic-card-vertical
                :statistic="other.card4"
                class="pt-0 pb-1"
                color="danger"
                icon="CornerUpLeftIcon"
                statistic-title="Đơn trả hàng"
            />
          </b-col>
        </b-row>
      </b-col>

      <!--/ Revenue Report Card -->
    </b-row>

    <b-row class="match-height">
      <b-col lg="4" md="4">
        <b-card v-if="transactionData" class="card-transaction" no-body>
          <b-card-header>
            <b-card-title>Danh sách đơn hàng mới tiếp nhận</b-card-title>
          </b-card-header>

          <b-card-body style="max-height: 330px; overflow: auto">
            <div
                v-for="transaction in transactionData"
                :key="transaction.Id"
                class="transaction-item"
            >
              <b-media no-body>
                <b-media-aside>
                  <span class="badge badge-light-info badge-pill">{{
                    transaction.Id
                  }}</span>
                </b-media-aside>
                <b-media-body>
                  <h6 class="transaction-title">
                    {{ transaction.FullName }}
                  </h6>
                  <small>{{ transaction.ContactPhone }}</small>
                </b-media-body>
              </b-media>
              <div class="font-weight-bolder text-danger">
                {{ transaction.TotalPrice | number }}đ
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="4" md="4" sm="6">
        <b-card v-if="timeline" no-body>
          <b-card-header>
            <b-card-title class="ml-25"> Dữ liệu từ GHTK</b-card-title>
          </b-card-header>

          <!-- timeline -->
          <b-card-body style="max-height: 330px; overflow: auto">
            <app-timeline>
              <app-timeline-item
                  v-for="(i, stt) in timeline"
                  :key="stt"
                  variant="primary"
              >
                <div
                    v-if="i && i.data && i.data.length > 0"
                    class="
                    d-flex
                    justify-content-between
                    flex-sm-row flex-column
                    mb-sm-0 mb-1
                  "
                >
                  <h6>{{ i.data[0].date_ }}</h6>
                  <small
                      class="timeline-item-time text-nowrap text-muted ml-1"
                  >{{ i.Id }}</small
                  >
                </div>
                <p v-if="i && i.data && i.data.length > 0">
                  {{ i.data[0].text }}
                </p>
              </app-timeline-item>
            </app-timeline>
            <!--/ timeline -->
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="4" md="4" sm="6">
        <b-card no-body>
          <b-card-header>
            <b-card-title>Tỉ lệ loại số</b-card-title>
            <!-- dropdown -->
            <!--/ dropdown -->
          </b-card-header>

          <!-- chart -->
          <b-card-body>
            <!--<vue-apex-charts v-if="!isLoading" ref="donutChartRef"
              type="donut"
              height="350"
              :options="donutChart.chartOptions"
              :series="donutChart.series"
            />-->
            <vue-apex-charts
                id="treemap"
                ref="donutChartRef"
                :options="donutChart1.chartOptions"
                :series="donutChart1.series"
                height="350"
                type="treemap"
            >
            </vue-apex-charts>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BImg,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BProgress,
  BRow,
  BTab,
  BTabs,
} from "bootstrap-vue";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import useJwt from "@/auth/jwt/useJwt";
import Select2 from "v-select2-component";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Ripple from "vue-ripple-directive";
import {kFormatter} from "@core/utils/filter";
import VueApexCharts from "vue-apexcharts";
import {$themeColors} from "@themeConfig";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import {PolarArea} from "vue-chartjs";
import EventBus from "@/store/EventBus";
import moment from "moment";

const $barColor = "#f3f3f3";
const $trackBgColor = "#EBEBEB";
const $earningsStrokeColor2 = "#ED1F2466";
const $earningsStrokeColor3 = "#ED1F2433";
const chartColors = {
  column: {
    series1: "#826af9",
    series2: "#d2b0ff",
    bg: "#f8d3ff",
  },
  success: {
    shade_100: "#7eefc7",
    shade_200: "#06774f",
  },
  donut: {
    series1: "#ffe700",
    series2: "#00d4bd",
    series3: "#826bf8",
    series4: "#2b9bf4",
    series5: "#FFA1A1",
  },
  area: {
    series3: "#a4f8cd",
    series2: "#60f2ca",
    series1: "#2bdac7",
  },
};

export default {
  components: {
    BProgress,
    PolarArea,
    AppTimeline,
    AppTimelineItem,
    StatisticCardHorizontal,
    StatisticCardVertical,
    VueApexCharts,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BLink,
    BImg,
    BCardHeader,
    BButton,
    BCardBody,
    BCardTitle,
    kFormatter,
    Ripple,
    BRow,
    BCol,
    VuePdfApp,
    Select2,
    BCard,
    flatPickr,
    BTab,
    BCardText,
    BTabs,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      other: {
        toDayCount: 0,
        toDaySum: 0,
        toDaySimCount: 0,
        card1: 0,
        card2: 0,
        card3: 0,
        card4: 0,
        trackRate: 0,
      },
      fromDate: "",
      toDate: "",
      mainCode: null,
      subCode: null,
      congratulations: {
        name: "John",
        expectation: "0",
        actual: "",

      },
      statisticsItems: [
        {
          icon: "TrendingUpIcon",
          color: "light-primary",
          title: "0",
          subtitle: "Tổng đơn",
          customClass: "mb-2 mb-xl-0",
        },
        {
          icon: "UserIcon",
          color: "light-info",
          title: "0",
          subtitle: "Tổng SIM",
          customClass: "mb-2 mb-xl-0",
        },
        {
          icon: "BoxIcon",
          color: "light-danger",
          title: "0",
          subtitle: "Đơn xử lý thành công",
          customClass: "mb-2 mb-sm-0",
        },
        {
          icon: "DollarSignIcon",
          color: "light-secondary",
          title: "0",
          subtitle: "Đơn tồn",
          customClass: "",
        },
        {
          icon: "BoxIcon",
          color: "light-primary",
          title: "0",
          subtitle: "Tổng đơn phát sinh",
          customClass: "mb-2 mb-xl-0",
        },
        {
          icon: "BoxIcon",
          color: "light-primary",
          title: "0",
          subtitle: "Tổng sim phát sinh",
          customClass: "mb-2 mb-xl-0",
        },
      ],
      statisticsOrder: {
        chartOptions: {
          chart: {
            type: "bar",
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          grid: {
            borderColor: $trackBgColor,
            xaxis: {
              lines: {
                show: false,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
            padding: {
              top: -30,
              bottom: -10,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "50%",
            },
          },
          stroke: {
            width: 0,
          },
          colors: [$themeColors.info],
          markers: {
            size: 2,
            colors: $themeColors.info,
            strokeColors: $themeColors.info,
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [
              {
                seriesIndex: 0,
                dataPointIndex: 5,
                fillColor: "#ffffff",
                strokeColor: $themeColors.info,
                size: 5,
              },
            ],
            shape: "circle",
            radius: 2,
            hover: {
              size: 3,
            },
          },
          xaxis: {
            categories: ["a", "b", "c", "d"],
            labels: {
              show: true,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: true,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
        series: [
          {
            data: [1, 2, 3, 4],
          },
        ],
      },
      statisticsProfit: {
        chartOptions: {
          chart: {
            type: "line",
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          grid: {
            borderColor: $trackBgColor,
            strokeDashArray: 5,
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
            padding: {
              top: -30,
              bottom: -10,
            },
          },
          stroke: {
            width: 3,
          },
          colors: [$themeColors.primary],
          markers: {
            size: 2,
            colors: $themeColors.primary,
            strokeColors: $themeColors.primary,
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [
              {
                seriesIndex: 0,
                dataPointIndex: 5,
                fillColor: "#ffffff",
                strokeColor: $themeColors.primary,
                size: 5,
              },
            ],
            shape: "circle",
            radius: 2,
            hover: {
              size: 3,
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: null,
            labels: {
              show: true,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
        series: [
          {
            name: "Doanh thu",
            data: [0, 0, 0],
          },
        ],
      },
      earningsChart: {
        chartOptions: {
          chart: {
            type: "donut",
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {show: false},
          comparedResult: [0, 0, 0, 0],
          labels: ["Tìm số", "Chọn gói", "Nhập thông tin", "Thanh toán"],
          stroke: {width: 0},
          colors: ["#B4B4B4", "#FCB6B7", "#EF383C", "#D71A1F"],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`;
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
        series: [100, 50, 50, 50],
      },
      goalOverview: {
        completed: "786,617",
        inProgress: "13,561",
        series: [83],
      },
      transactionData: [],
      goal_overview: {
        completed: "0",
        inProgress: "0",
      },
      goalOverviewRadialBar: {
        series: [11],
        chartOptions: {
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: ["#ED1F24"],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77%",
              },
              track: {
                background: "#FB5055",
                strokeWidth: "50%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: "#FB5055",
                  fontSize: "2.86rem",
                  fontWeight: "600",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
      timeline: {},
      donutChart: {
        series: [85, 16, 50, 50],
        chartOptions: {
          legend: {
            show: true,
            position: "right",
            fontSize: "11px",
            fontFamily: "Montserrat",
            formatter: function (seriesName, opts) {
              var t = 0;
              opts.w.globals.series.forEach((m) => {
                t = t + m;
              });
              return [
                seriesName,
                " - ",
                opts.w.globals.series[opts.seriesIndex],
              ];
            },
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "1.5rem",
                    fontFamily: "Montserrat",
                    formatter: function (val) {
                      return val;
                    },
                  },
                  value: {
                    fontSize: "1.5rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)} số`;
                    },
                  },
                },
              },
            },
          },
          labels: ["Operational", "Networking", "Hiring", "R&D"],
        },
      },
      donutChart1: {
        chart: {
          foreColor: "#ffffff",
        },
        series: [
          {
            data: [{x: "test", y: 10}],
          },
        ],
        chartOptions: {
          legend: {
            show: false,
          },
          chart: {
            height: "100%",
            type: "treemap",
            foreColor: "#ffffff",
            toolbar: {
              show: false,
            },
          },
          colors: [
            "#3B93A5",
            "#F7B844",
            "#ADD8C7",
            "#EC3C65",
            "#CDD7B6",
            "#C1F666",
            "#D43F97",
            "#1E5D8C",
            "#421243",
            "#7F94B0",
            "#EF6537",
            "#C0ADDB",
          ],
          dataLabels: {
            enabled: true,
            distributed: false,
            style: {
              fontSize: "12px",
            },

            formatter: function (text, op) {
              return [text, op.value];
            },
          },
          plotOptions: {
            treemap: {
              distributed: true,
              enableShades: false,
            },
          },
        },
      },
      ghtkStatus: [
        {id: "-1", text: "Hủy đơn hàng"},
        {id: "1", text: "Chưa tiếp nhận"},
        {id: "2", text: "Đã tiếp nhận"},
        {id: "3", text: "Đã lấy hàng/Đã nhập kho"},
        {id: "4", text: "Đã điều phối giao hàng/Đang giao hàng"},
        {id: "5", text: "Đã giao hàng/Chưa đối soát"},
        {id: "6", text: "Đã đối soát"},
        {id: "7", text: "Không lấy được hàng"},
        {id: "8", text: "Hoãn lấy hàng"},
        {id: "9", text: "Không giao được hàng"},
        {id: "10", text: "Delay giao hàng"},
        {id: "11", text: "Đã đối soát công nợ trả hàng"},
        {id: "12", text: "Đã điều phối lấy hàng/Đang lấy hàng"},
        {id: "13", text: "Đơn hàng bồi hoàn"},
        {id: "20", text: "Đang trả hàng (COD cầm hàng đi trả)"},
        {id: "21", text: "Đã trả hàng (COD đã trả xong hàng)"},
        {id: "123", text: "Shipper báo đã lấy hàng"},
        {
          id: "127",
          text: "Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng",
        },
        {id: "128", text: "Shipper báo delay lấy hàng"},
        {id: "45", text: "Shipper báo đã giao hàng"},
        {id: "49", text: "Shipper báo không giao được giao hàng"},
        {id: "410", text: "Shipper báo delay giao hàng"},
      ],
      funnelChart: null,
      funnelChartData: [],
      funnelChartConfig: {
        tooltip: {
          trigger: "none",
          triggerOn: "none",
        },
        // toolbox: {
        //   feature: {
        //     dataView: { readOnly: false },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        legend: {
          data: ["Show", "Click", "Visit", "Inquiry", "Order"],
        },
        series: [
          {
            name: "Funnel",
            type: "funnel",
            left: "0",
            top: 0,
            bottom: 0,
            width: "100%",
            min: 0,
            max: 100,
            minSize: "0%",
            maxSize: "100%",
            gap: 0,
            label: {
              show: true,
              position: "inside",
              fontSize: 20,
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 3,
                type: "solid",
              },
            },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1,
            },
            data: [],
          },
        ],
      },
      isMounted: false,
    };
  },
  watch: {},
  mounted() {
    this.isMounted = true;
    try {
      var u = JSON.parse(localStorage.userData);
      if (u.role == "AGENCY") {
        this.$router.push({name: "home-blank"});
      }
    } catch (err) {
    }
    EventBus.$on("dashboardFromDate", this.changeFromDate);
    EventBus.$on("dashboardToDate", this.changeToDate);
    EventBus.$on("dashboardMainCode", this.changeMainCode);
    EventBus.$on("dashboardSubCode", this.changeSubCode);
    this.fromDate = moment().startOf('month').format("YYYY-MM-DD");
    this.toDate = moment().format("YYYY-MM-DD");
    this.loadData();
    this.isMounted = false;
  },
  destroyed() {
    EventBus.$off("dashboardFromDate");
    EventBus.$off("dashboardToDate");
    EventBus.$off("dashboardMainCode");
    EventBus.$off("dashboardSubCode");
    //this.funnelChart.destroy();
  },
  created() {
  },
  methods: {
    getTypeNameStep(data) {
      if (data.step == 1) return `Tìm kiếm - ${data.c}`;
      if (data.step == 2) return `Chọn gói - ${data.c}`;
      if (data.step == 3) return `Nhập thông - ${data.c}`;
      return `Thanh toán - ${data.c}`;
    },
    changeFromDate(e) {
      this.fromDate = e;
      this.loadData();
    },
    changeToDate(e) {
      this.toDate = e;
      this.loadData();
    },
    changeMainCode(e) {
      this.mainCode = e ? parseInt(e) : null;
      this.loadData();
    },
    changeSubCode(e) {
      this.subCode = e ? parseInt(e) : null;
      this.loadData();
    },
    loadData() {
      if (!this.isMounted) {
        this.loading(true);
      }
      if (this.fromDate == "" || this.toDate == "") {
        return;
      }
      this.isLoading = true;
      useJwt
          .post("dashboard", {
            fromDate: this.fromDate,
            toDate: moment(this.toDate, "YYYY-MM-DD")
                .add(1, "days")
                .format("YYYY-MM-DD"),
            MainCode: this.mainCode,
            SubCode: this.mainCode === 1 ? this.subCode : null,
          })
          .then((response) => {
            var data = response.data.result;
            this.other.toDaySimCount = data.toDaySimCount;
            this.other.toDayCount = data.toDayCount;
            this.other.toDaySum = data.toDaySum;
            this.congratulations.expectation = data.RA;
            this.congratulations.actual = data.TAS;
            this.statisticsItems[0].title = data.statisticsItem1;
            this.statisticsItems[1].title = data.statisticsItem2;
            this.statisticsItems[2].title = data.statisticsItem3;
            this.statisticsItems[3].title = data.statisticsItem4;
            this.statisticsItems[4].title = data.statisticsItem5;
            this.statisticsItems[5].title = data.statisticsItem6;
            this.goal_overview.completed = data.statisticsItem3;
            this.goal_overview.inProgress = data.statisticsItem4;
            this.goalOverviewRadialBar.series = [
              Math.round((data.statisticsItem3 * 100) / data.statisticsItem1),
            ];
            this.other.card1 = data.card1;
            this.other.card2 = data.card2;
            this.other.card3 = data.card3;
            this.other.card4 = data.card4;

            data.simType.forEach((i) => {
              i.y = i.c;
              i.x = i.group_name;
            });
            this.donutChart1.series = [
              {
                data: data.simType,
              },
            ];

            this.transactionData = data.newOrder;

            this.timeline = data.shipTrack;
            console.log(this.timeline);
            this.timeline.forEach((i) => {
              i.data = JSON.parse(i.J_Shipment_Tracking);

              i.data.forEach((j) => {
                const status = this.ghtkStatus.find((m) => m.id == j.status);
                if (status) j.text = status.text;
                else j.text = j.status;
              });
            });

            this.statisticsOrder.series = [
              {data: data.Tran7.map((i) => i.total)},
            ];
            this.statisticsOrder.chartOptions = {
              xaxis: {
                categories: data.Tran7.map((i) => i.d),
              },
            };

            this.statisticsProfit.series = [
              {data: data.Tran7.map((i) => i.price)},
            ];
            this.statisticsProfit.chartOptions = {
              xaxis: {
                categories: data.Tran7.map((i) => i.d),
              },
            };

            const timKiem = data.track.find((i) => i.step == 1);
            const chonGoi = data.track.find((i) => i.step == 2);
            const nhapThongTin = data.track.find((i) => i.step == 3);
            const thanhToan = data.track.find((i) => i.step == 4);
            if (timKiem) {
              this.earningsChart.series = [
                100,
                Math.round(
                    ((chonGoi !== undefined ? chonGoi.c : 0) * 100) / timKiem.c
                ),
                Math.round(
                    ((nhapThongTin !== undefined ? nhapThongTin.c : 0) * 100) /
                    timKiem.c
                ),
                Math.round(
                    ((thanhToan !== undefined ? thanhToan.c : 0) * 100) / timKiem.c
                ),
              ];
            }

            this.other.trackRate = Math.round((thanhToan.c * 100) / timKiem.c);

            this.$refs.statisticsOrderRef.updateOptions({
              xaxis: {
                categories: data.Tran7.map((i) => i.d),
              },
            });
            console.log(data.Tran7.map((i) => i.total));
            this.$refs.statisticsOrderRef.updateSeries([
              {
                data: data.Tran7.map((i) => i.total),
              },
            ]);

            this.$refs.statisticsProfitRef.updateOptions({
              xaxis: {
                categories: data.Tran7.map((i) => i.d),
              },
            });
            this.$refs.statisticsProfitRef.updateSeries([
              {
                data: data.Tran7.map((i) => i.price),
              },
            ]);

            //this.donutChart.series = data.simType.map(i=>i.c);
            //this.donutChart.chartOptions.labels = data.simType.map(i=>i.group_name);

            // add data for funnel chart
            /*this.funnelChartData = data.track
            .filter(t => t.step > 0)
            .sort((a,b) => a.step - b.step)
            .map(t => ({ name: this.getTypeNameStep(t), value: t.c }));
          // this.funnelChart = new D3Funnel('#funnel');
          // this.funnelChart.draw(this.funnelChartData, this.funnelChartConfig);
          // end

          var chartDom = document.getElementById('funnel');
          var myChart = echarts.init(chartDom);
          this.funnelChartConfig.series[0].data = this.funnelChartData;

          this.funnelChartConfig && myChart.setOption(this.funnelChartConfig);*/

            this.loading(false);
            this.isLoading = false;
          })
          .catch((error) => {
            this.loading(false);
          });
    },
    kFormatter,
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";

.center-chart {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
</style>
